import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { MedicalDocumentRepositoryTable } from './MedicalDocumentRepositoryTable/MedicalDocumentRepositoryTable';

type MedicalDocumentRepositoryPanelProps = {
   readonly patient: Patient;
};

const MedicalDocumentRepositoryPanel = (props: MedicalDocumentRepositoryPanelProps): JSX.Element => {
   return <MedicalDocumentRepositoryTable patientId={props.patient.id} />;
};

export { MedicalDocumentRepositoryPanel };
